import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { dismissToast } from "../../store/slices/toastSlice";
import "./app-toasts.css";

function ToastItem({ toast }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const ms = toast.durationMs ?? 5200;
    const t = window.setTimeout(() => {
      dispatch(dismissToast(toast.id));
    }, ms);
    return () => window.clearTimeout(t);
  }, [dispatch, toast.id, toast.durationMs]);

  return (
    <div
      className={`app-toasts__item app-toasts__item--${toast.variant}`}
      role="status"
      aria-live="polite"
    >
      <span className="app-toasts__mark" aria-hidden />
      <div className="app-toasts__body">
        {toast.title ? <p className="app-toasts__title">{toast.title}</p> : null}
        {toast.message ? <p className="app-toasts__message">{toast.message}</p> : null}
      </div>
      <button
        type="button"
        className="app-toasts__close"
        aria-label="Dismiss notification"
        onClick={() => dispatch(dismissToast(toast.id))}
      >
        ×
      </button>
    </div>
  );
}

export default function AppToasts() {
  const items = useAppSelector((s) => s.toast.items);
  if (!items.length) return null;
  return (
    <div className="app-toasts" aria-label="Notifications">
      {items.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}
